import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';

Vue.use(Vuex)
Vue.use(ElementUI);

//const url = 'http://'+window.location.hostname+':8000/api';
// const url = 'http://app-laravel:8000/api';
// const url = 'http://172.23.0.4:8000/api';
const url = '/api';



export default new Vuex.Store({
    state: {
        status: '',
        token: localStorage.getItem('token') || '', 
        user : localStorage.getItem('usuario_nome') || '',
        pageSize: '' 
    },
    mutations: {
        auth_request(state){ state.status = 'loading'},
        auth_success_user(state, user){state.status = 'success'; state.user = user;},
        auth_success(state, token){state.status = 'success'; state.token = token;},
        auth_error(state){ state.status = 'error'},
        logout(state){ state.status = ''; state.token = '',state.user = ''},
	},
	actions: {
        login({commit}, user){
            return new Promise((resolve, reject) => {
                commit('auth_request')
                axios({url: url+'/login', data: user, method: 'POST'})
                .then(resp => {
                    // console.log('dentro do store.js, após login', resp.data);
                    const token = resp.data.token
                    const user = resp.data.user
                    const fabricante_qtde = resp.data.fabricantes_qtde

                    localStorage.setItem('token', token)
                    localStorage.setItem('usario_nome', user)
                    localStorage.setItem('fabricante_qtde', fabricante_qtde)

                    // Add the following line:
                    axios.defaults.headers.common['Authorization'] = "Bearer " + token;
                    //ALTEREI ESSA LINHA PARA NÃO DAR ERRO
                    commit('auth_success', token, user);
                    commit('auth_success_user', user);
              
                    resolve(resp);
                })
                .catch(err => {
                    commit('auth_error')
                    localStorage.removeItem('token');
                    localStorage.removeItem('usario_nome');
                    localStorage.removeItem('fabricante_nome')
                    localStorage.removeItem('fabricante_qtde')
                    reject(err)
                })
                
            })
        },
        register({commit}, user){
            return new Promise((resolve, reject) => {
                commit('auth_request')
                axios({url: url+'/register', data: user, method: 'POST' })
                .then(resp => {
                    const token = resp.data.token
                    const user = resp.data.user
                    localStorage.setItem('token', token)
                    // Add the following line:
                    axios.defaults.headers.common['Authorization'] = token
                    commit('auth_success', token, user)
                    resolve(resp)
                })
                .catch(err => {
                    commit('auth_error', err)
                    localStorage.removeItem('token');
                    alert('Erro ao acessar a base de dados! Por favor, aguarde alguns minutos e tente novamente!');
                    reject(err)
                })
            })
        },
        logout({commit}){
            return new Promise((resolve) => {
                commit('logout')
                localStorage.removeItem('token')
                localStorage.removeItem('usario_nome')
                localStorage.removeItem('fabricante_nome')
                localStorage.removeItem('fabricante_qtde')
                delete axios.defaults.headers.common['Authorization']
                resolve()
            })
        },
        //LISTA COMISSÃO
        listaComissao({commit}, limit){
            return new Promise((resolve, reject) => {
                axios.get(url+"/list_config_comissao/0/"+limit, {
                    headers: {
                      Authorization: "Bearer " + this.getters.isToken,
                    },
                  })
                    .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    commit('auth_error')
                    localStorage.removeItem('token');
                    reject(err)
                })
            })
        },        
        //LISTA RENTABILIDADE
        listaRentabilidade({commit}, limit){
            return new Promise((resolve, reject) => {
                axios.get(url+"/list_config_rentab/0/"+limit, {
                    headers: {
                      Authorization: "Bearer " + this.getters.isToken,
                    },
                  })
                    .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    commit('auth_error')
                    localStorage.removeItem('token');
                    reject(err)
                })
            })
        },        
    },
    getters : {
        isLoggedIn: state => !!state.token,
        isUser: state => state.user ,
        authStatus: state => state.status,
        isToken: state => state.token,
	}
})